import React from "react";
import { alpha, Box, Stack, Typography } from "@mui/material";
import { Neutrals, SemanticError } from "../../core-components/theme/color-palette/colors";
import { getIconTypeFromMime } from "../../utilities/helpers";
import SpriteIcon from "../../core-components/assets/Icon";

const FileConflictComponent = ({files}: any) => {
  const renderIcon = (fileObj: any) => {
    const iconType = getIconTypeFromMime(fileObj?.type);
    return <SpriteIcon id={iconType} width="20" height="20"/>
  }

  const renderConflitFiles = (fileObj: any, index: number) => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }} key={index + fileObj?.name}>
        {renderIcon(fileObj)}
        <Typography variant="caption2" sx={{ fontWeight: 600, color: Neutrals[600] }}>{fileObj?.name}</Typography>
      </Box>
    )
  }
  return (
    <React.Fragment>
        <Stack
          rowGap={1}
          sx={{
            padding: '16px',
            borderRadius: '8px',
            background: alpha(SemanticError[50], 0.3),
            border: `1px solid ${SemanticError[50]}`,
            overflowY: 'auto',
            maxHeight: '55px'
          }}
          >
            {
              files?.map((fileObj: any, index: number) => (renderConflitFiles(fileObj?.file, index)))
            }
      </Stack>
    </React.Fragment>
  )
}

export default FileConflictComponent;